import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { checkSignedIn, selectAuthStatus } from "reducers/auth";

export function useCheckSignedIn(): boolean {
  const dispatch = useDispatch();
  const authStatus = useSelector(selectAuthStatus);

  useEffect(() => {
    dispatch(checkSignedIn());
  }, [dispatch]);

  // Debugging log removed. Uncomment if needed for debugging.
  // console.log("useCheckSignedIn(): " +  (authStatus === "signed_in"));

  return authStatus === "signed_in";
}
